import type {
  MerchantType,
  PaidStatus,
  TradeBuyer,
  TradeDuration,
  TradeOrder,
  TradeOrderDetail,
  TradePageInfo,
  TradeStats,
} from '@/typings/trade'
import { stringifySearchParams } from '../utils/url'
import { getAuthToken } from './authToken'

type TradeApiResult<T> = { data: T; error?: undefined } | { data?: undefined; error: string }

async function tradeFetch<T>(path: string): Promise<TradeApiResult<T>> {
  let res: Response
  try {
    res = await fetch(`${process.env.EXPO_PUBLIC_API_BASE_URL}/api/v5/internal/trade${path}`, {
      headers: { Accept: 'application/json', Authorization: getAuthToken() ?? '' },
    })
  } catch (error) {
    return { error: String(error) }
  }

  let json
  try {
    json = await res.json()
  } catch {
    // non-JSON body (e.g. an HTML error page)
  }

  if (!res.ok) {
    return { error: json?.errorMessage || json?.message || json?.error || res.statusText || `HTTP ${res.status}` }
  }
  return { data: json as T }
}

export type TradeOrdersParams = {
  type: MerchantType
  page: number
  duration: TradeDuration
  paidStatus: PaidStatus | 'all'
}

export function getTradeOrders(params: TradeOrdersParams) {
  return tradeFetch<{ data: TradeOrder[]; pageInfo: TradePageInfo }>(
    `/orders?${stringifySearchParams({
      type: params.type,
      page: params.page,
      duration: params.duration,
      paid_status: params.paidStatus,
    })}`
  )
}

export function getTradeStats(params: { type: MerchantType; duration: TradeDuration }) {
  return tradeFetch<{ data: TradeStats }>(`/stats?${stringifySearchParams(params)}`)
}

export function getTradeOrder(id: string) {
  return tradeFetch<{ data: TradeOrderDetail }>(`/orders/${encodeURIComponent(id)}`)
}

export function getTradeOrderBuyer(formToken: string, id: string) {
  return tradeFetch<{ data: { buyer: TradeBuyer | null } }>(
    `/payment_form/${encodeURIComponent(formToken)}/orders/${encodeURIComponent(id)}`
  )
}
